import styles from "./FullScreenLoader.module.css";
const FullScreenLoader = ({ loaderTitle }) => {
  return (
    <div className={styles.fullscreenLoader}>
      <div className={styles.loaderContent}>
        <div className={styles.spinner}></div>
        <p>{loaderTitle || "Loading..."}</p>
      </div>
    </div>
  );
};

export default FullScreenLoader;
